module.exports = __webpack_public_path__ + "img/SGH08.9a391ef4.jpg";